import type { ReactNode } from "react";
import { Icon, type IconName } from "../Icon";
import type { Tone } from "./StatusPill";

const ICON: Record<Tone, IconName> = {
  neutral: "info",
  info: "info",
  success: "checkCircle",
  warning: "alert",
  error: "error",
};

interface BannerProps {
  tone: Tone;
  title?: ReactNode;
  children?: ReactNode;
  /** "alert" interrupts screen readers; use only for errors that just happened. */
  live?: "polite" | "alert" | "off";
  icon?: IconName;
}

/** Persistent in-page callout. Not dismissible: UX-DESIGN.md's banners (spend freeze, shadow mode) must stay. */
export function Banner({ tone, title, children, live = "off", icon }: BannerProps) {
  const role = live === "alert" ? "alert" : live === "polite" ? "status" : undefined;
  return (
    <div className={`banner banner-${tone}`} role={role}>
      <Icon name={icon ?? ICON[tone]} />
      <div className="banner-body">
        {title ? <div className="banner-title">{title}</div> : null}
        {children ? <div>{children}</div> : null}
      </div>
    </div>
  );
}
